import { render, staticRenderFns } from "./AddressSearch.vue?vue&type=template&id=6fedfef9&scoped=true&"
import script from "./AddressSearch.vue?vue&type=script&lang=ts&"
export * from "./AddressSearch.vue?vue&type=script&lang=ts&"
import style0 from "./AddressSearch.vue?vue&type=style&index=0&id=6fedfef9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fedfef9",
  null
  
)

export default component.exports